__turbopack_context__.v({
  "content": "ScreenStateInfo-module__3JWxFa__content",
  "description": "ScreenStateInfo-module__3JWxFa__description",
  "header": "ScreenStateInfo-module__3JWxFa__header",
  "root": "ScreenStateInfo-module__3JWxFa__root",
  "title": "ScreenStateInfo-module__3JWxFa__title",
});
